export enum UploadErrorCodes {
  SubmitThrottled="SubmitRateLimit",
  UploadThrottled="UploadRateLimit",
}
